<div class="fullscreen-bg {{ class }}" style="background-image: url('{{ src }}'); background-color: {{ bgcolor }}; color: {{ color }};">
    <div class="container">
        <h4 class="mt-4 fullscreen-title" *ngIf="title" style="color: {{ color }};  border-bottom: 1px solid {{ color }};">{{ title }}</h4>
        <ng-content></ng-content>
    </div>
</div>